import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { FloatLabel } from "../../Utils/CustomComponent";

const UseFormRadio = ({
  title,
  options,
  field,
  register,
  watch,
  type,
  errors,
  setValue,
  disable,
  value,
}) => {
  const value1 = watch(field);

  useEffect(() => {
    register(field);
    setValue(field, value);
  }, [field, register, setValue]);
  return (
    <div className={`form-group`}>
      <FloatLabel
        label={title}
        value={1}
        className={errors?.[field]?.message && !value1 ? "text-error" : ""}
      >
        <div className="form-control input-lg p-5">
          {options?.map((data2, index) => (
            <Form.Check
              key={index}
              type={type}
              label={data2.title}
              id={data2.title}
              isInvalid={errors?.[field] && !value1}
              checked={value1 === data2.value}
              onChange={(e) => setValue(field, data2.value)}
              className={
                errors?.[field]?.message && !value1 ? "is-invalid" : ""
              }
              disabled={disable}
            />
          ))}
        </div>
      </FloatLabel>
      {errors?.[field]?.message && !value1 ? (
        <div className="d-block invalid-feedback">
          {errors?.[field]?.message}
        </div>
      ) : null}
    </div>
  );
};

export default UseFormRadio;
